<template>
  <div>
    <Head title="Create User" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/users">Users</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>

    <UserForm
      :form="form"
      :projects="projects"
      :organizations="organizations"
      :logged-user-type="loggedUserType"
      :can-select-project="canSelectProject"
      :submit="store"
    >
      <template #actions>
        <Link class="text-blue-600 hover:underline mr-2" tabindex="-1" href="/users">Go back</Link>
        <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Create User</loading-button>
      </template>
    </UserForm>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import UserForm from '@/Pages/Users/UserForm.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'


export default {
  components: {
    LoadingButton,
    Head,
    Link,
    UserForm,
  },
  layout: Layout,
  props: {
    projects: Array,
    organizations: Array,
    loggedUser: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        type:  null,
        organization_id: null,
        owner: false,
        photo: null,
        project_id: null,
      }),
    }
  },
  computed: {
    loggedUserType() {
      return this.loggedUser.type
    },
    canSelectProject() {
      return this.loggedUser.type === 'ADMIN' ||
        (this.loggedUser.type === 'PARTNER' && this.loggedUser.type === 'TECHNICIAN')
    },
  },
  methods: {
    store() {
      this.form.post('/users')
    },
  }
}
</script>
